import get from 'lodash/get';
import {
  ADD_MATERIAL,
  ADD_MATERIAL_FAILURE,
  ADD_MATERIAL_SUCCESS,
  FETCH_MATERIALS,
  FETCH_MATERIALS_SUCCESS,
  FETCH_MATERIALS_FAILURE,
  UPDATE_MATERIAL,
  UPDATE_MATERIAL_SUCCESS,
  UPDATE_MATERIAL_FAILURE,
  BULK_UPLOAD_MATERIALS,
  BULK_UPLOAD_MATERIALS_SUCCESS,
  BULK_UPLOAD_MATERIALS_FAILURE,
} from './types';

const initialState = {
  materialsData: [],
  materialsCount: 0,
  isMaterialsLoading: false,
  isAddUpdateMaterial: false,
  isBulkUploadMaterials: false,
};

const materialsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_MATERIALS: {
      return {
        ...state,
        isMaterialsLoading: true,
      };
    }

    case FETCH_MATERIALS_SUCCESS: {
      const resData = get(action, 'response', []);
      const count = get(action, 'count', 0);
      return {
        ...state,
        materialsData: resData,
        materialsCount: count,
        isMaterialsLoading: false,
      };
    }

    case FETCH_MATERIALS_FAILURE: {
      return {
        ...state,
        isMaterialsLoading: false,
      };
    }

    case ADD_MATERIAL: {
      return {
        ...state,
        isAddUpdateMaterial: true,
      };
    }

    case ADD_MATERIAL_SUCCESS: {
      return {
        ...state,
        isAddUpdateMaterial: false,
      };
    }

    case ADD_MATERIAL_FAILURE: {
      return {
        ...state,
        isAddUpdateMaterial: false,
      };
    }

    case UPDATE_MATERIAL: {
      return {
        ...state,
        isAddUpdateMaterial: true,
      };
    }

    case UPDATE_MATERIAL_SUCCESS: {
      return {
        ...state,
        isAddUpdateMaterial: false,
      };
    }

    case UPDATE_MATERIAL_FAILURE: {
      return {
        ...state,
        isAddUpdateMaterial: false,
      };
    }

    case BULK_UPLOAD_MATERIALS: {
      return {
        ...state,
        isBulkUploadMaterials: true,
      };
    }

    case BULK_UPLOAD_MATERIALS_SUCCESS: {
      return {
        ...state,
        isBulkUploadMaterials: false,
      };
    }

    case BULK_UPLOAD_MATERIALS_FAILURE: {
      return {
        ...state,
        isBulkUploadMaterials: false,
      };
    }

    default: {
      return state;
    }
  }
};

export default materialsReducer;

